<template>
  <TeamActionsOverview action-id="1000km,1000kmint" :per-page="20">
    <template v-slot="{ row }">
      <div class="col col-md-6 mb-4">
        <div class="kotk-team-action kotk-team-action--100kmrun_team_action team-action view-mode--teaser" :data-id="row.drupal_internal__id">
          <div class="teaser">
            <a :href="[path, row.id].join('/')" class="teaser__url d-flex align-items-stretch">
              <div v-if="row.field_date_start" class="col-3 py-3 d-flex align-items-center justify-content-center bg-secondary-15">
                <div class="teaser__date text-align-center">
                  <time class="action-date action-date--start d-block" datetime="{{ row.field_date_start }}">
                    <span class="action-date__month d-block font-weight-bold">{{ $helpers.formatDateMonthShortName(row.field_date_start) }}</span>
                    <span class="action-date__day d-block h3 mb-0">{{ $helpers.formatDateDay(row.field_date_start) }}</span>
                    <span class="action-date__year sr-only">{{ $helpers.formatDateYear(row.field_date_end) }}</span>
                  </time>
                  <time v-if="row.field_date_end && $helpers.formatDateFull(row.field_date_end) !== $helpers.formatDateFull(row.field_date_start)" class="action-date action-date--end d-block" datetime="{{ row.field_date_end }}">
                    <span class="action-date__month d-block font-weight-bold">{{ $helpers.formatDateMonthShortName(row.field_date_end) }}</span>
                    <span class="action-date__day d-block h3 mb-0">{{ $helpers.formatDateDay(row.field_date_end) }}</span>
                    <span class="action-date__year sr-only">{{ $helpers.formatDateYear(row.field_date_end) }}</span>
                  </time>
                </div>
              </div>

              <div class="col py-3">
                <div class="teaser__content">
                  <h4 class="teaser__title h5 mb-1">{{ row.label }}</h4>
                  <div class="teaser__team">Door {{ row.team.label }}</div>
                  <div v-if="row.field_address_city" class="teaser__location">{{ row.field_address_city }}</div>
                </div>
              </div>
            </a>
          </div>
        </div>

      </div>
    </template>
  </TeamActionsOverview>
</template>

<script>
import TeamActionsOverview from "@/components/Views/AdvancedTeamActionsOverview.vue";

export default {
  name: "DkmTeamActionsOverview",
  components: {
    TeamActionsOverview,
  },
  data() {
    return {
      path: this.$window.location.pathname,
    }
  }
}
</script>
